import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restrictedDescriptionTwoLevels: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restrictedDescriptionThreeOrMoreLevels: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreInformation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorLoadingInheritancePopupTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorLoadingInheritancePopupMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'issue-field-atlas-project-common.inheritance-popup.title',
		defaultMessage: 'Inherited project',
		description: 'Title of the inheritance popup, indicating that this atlas project is inherited',
	},
	description: {
		id: 'issue-field-atlas-project-common.inheritance-popup.description',
		defaultMessage:
			'This work item’s project comes from its parent work item. To change the project, select {workItemKey} below.',
		description:
			'Description of the inheritance popup, indicating that the atlas project comes from the parent work item',
	},
	restrictedDescriptionTwoLevels: {
		id: 'issue-field-atlas-project-common.inheritance-popup.restricted-description-two-levels',
		defaultMessage:
			'This project comes from its parent work item, which you don’t have access to. Contact your admin if you want to change this project.',
		description:
			'Description of the inheritance popup when the user doesn’t have access to the parent work item and there are only two levels in the inheritance relationship',
	},
	restrictedDescriptionThreeOrMoreLevels: {
		id: 'issue-field-atlas-project-common.inheritance-popup.restricted-description-three-or-more-levels',
		defaultMessage:
			'This project comes from a work item that you don’t have access to. Contact your admin if you want to change this project.',
		description:
			'Description of the inheritance popup when the user doesn’t have access to the parent work item and there are three or more levels in the inheritance relationship',
	},
	moreInformation: {
		id: 'issue-field-atlas-project-common.inheritance-popup.more-information',
		defaultMessage: 'More on project inheritance',
		description: 'Link to more information about project inheritance',
	},
	errorLoadingInheritancePopupTitle: {
		id: 'issue-field-atlas-project-common.inheritance-popup.error-loading.title',
		defaultMessage: "We couldn't load the inheritance details",
		description: 'Error message title when inheritance popup fails to load',
	},
	errorLoadingInheritancePopupMessage: {
		id: 'issue-field-atlas-project-common.inheritance-popup.error-loading.message',
		defaultMessage: 'Check your connection, then try again.',
		description: 'Error message when inheritance popup fails to load',
	},
});
export default messages;
